import { get, post } from 'utils/fetch';
import endpoints, { EEndpoints } from 'config/endpoints';
import { screenings as typesScreenings } from 'types';

const screenings = {
  getScreenings: () => {
    return get<typesScreenings.TScreeningJob[]>(`${endpoints[EEndpoints.screeningsGet]()}`);
  },
  createScreeningJob: (body: {adminId: string}) => {
    return post<{adminId: string}, null>(`${endpoints[EEndpoints.screeningCreate]()}`, body);
  }
}

export default screenings;
